<template>
  <div class="hello">
    <h1>Üdvözli az Nemzeti Hematológiai Betegségek Regisztere!</h1>
    <img src="./../assets/img/logo2.png" alt="NHBR" />
  </div>
</template>

<script>
export default {
  name: 'Index'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hello {
  img {
    max-height: 340px;
  }
}
</style>

